import { Component, View, OnInit } from 'angular2/core';
import { CORE_DIRECTIVES, DatePipe} from 'angular2/common';
import { ROUTER_DIRECTIVES, Router } from 'angular2/router';

import { Header } from '../layout/header/header';
import { Sidebar } from '../layout/sidebar/sidebar';
import { Company } from './company.model';
import { CompanyService } from './company.service';
import { AlertService, AlertMessage, MessageType } from '../alert/alert.service';
import { SearchPipe } from '../search/search-pipe';
import { SearchBox } from '../search/search-box';
import { PaginatePipe } from '../pagination/paginate-pipe';
import { PaginationService } from '../pagination/pagination-service';
import { PaginationCmp } from '../pagination/pagination';
import { SortPipe } from '../sort/sort-pipe';
import { SortCmp } from '../sort/sort';
import { SortService } from '../sort/sort-service';

declare var UIkit: any;

let template = require('./company-list.html');

@Component({
  selector: 'company-list',
  providers: [PaginationService]
})
@View({
  template: template,
  pipes: [DatePipe, SearchPipe, PaginatePipe, SortPipe],
  directives: [CORE_DIRECTIVES, ROUTER_DIRECTIVES, Header,
  Sidebar, SearchBox, PaginationCmp, SortCmp],
})
export class CompanyList implements OnInit {

  companies: Company[] = [];

  constructor(
    public router: Router,
    public companyService: CompanyService,
    private alertService: AlertService) { }

  ngOnInit() {
    this.loadCompanys();
  }

  loadCompanys() {
    this.companyService.list().subscribe(
      response => {
        this.companies = [];
        for (let company of response.json()) {
          this.companies.push(new Company().fromJson(company));
        }
      },
      error => {
        this.alert('Error al recuperar el listado de asociados', MessageType.Danger);
      }
    );
  }

  edit($event, company) {
    this.router.navigate(['/CompanyDetail', { id: company.id }]);
  }

  view($event, company) {
    this.router.navigate(['/CompanyView', { id: company.id }]);
  }

  delete($event, company) {
    let fn = () => {
      this.companyService.delete(company).subscribe(
        response => this.alert('Asociado borrado con éxito', MessageType.Success),
        error => this.alert('Error al borrar el asociado', MessageType.Danger)
      );
      this.router.renavigate();
    };
    this.confirm('¿Seguro que deseas borrar el asociado ' + company.title + '?', fn);
  }

  add() {
    this.router.navigate(['CompanyNew']);
  }

  alert(text: string, type: MessageType) {
    this.alertService.push({ text, type });
  }

  confirm(message: string, callback) {
    let ok = confirm(message);
    if (ok) {
      callback();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/company/company-list.ts
 **/